<div class="addlocation-header">
  <div class="addlocaton-title" l10nTranslate>
    <span *ngIf="selectedPermissions; else addLocationTpl" l10nTranslate> recordsSearch.editLocation</span>
    <ng-template #addLocationTpl>
      <span> {{ 'shared.addLocation' | xTranslate }}</span>
    </ng-template>
  </div>
  <mat-icon class="dialog__close" aria-hidden="false" aria-label="Close icon" mat-dialog-close>close</mat-icon>
</div>

<div [formGroup]="globalSection" class="recordtitle-content">
  <table aria-hidden="true" class="admin-location">
    <thead class="export-labels">
      <tr>
        <th scope="col" l10nTranslate>shared.globalRegion</th>
        <th scope="col" l10nTranslate>shared.division</th>
        <th scope="col" l10nTranslate>shared.market</th>
        <th scope="col" l10nTranslate>shared.submarket</th>
        <th scope="col" l10nTranslate>shared.productType</th>
      </tr>
    </thead>
    <tbody class="export-input">
      <tr>
        <th scope="col">
          <mat-form-field appearance="outline">
            <mat-select
              hideSingleSelectionIndicator="true"
              formControlName="globalRegionFC"
              id="globalRegionSelect"
              class="global-region"
              disableOptionCentering
            >
              <mat-option *ngFor="let region of globalRegionList" [value]="region">
                {{ region.value }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </th>
        <th scope="col">
          <mat-form-field appearance="outline">
            <mat-select
              hideSingleSelectionIndicator="true"
              formControlName="divisionFC"
              id="regionSelect"
              name="regionSelect"
              disableOptionCentering
            >
              <mat-option *ngFor="let division of divisionList" [value]="division">
                {{ division.value }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </th>
        <th scope="col">
          <mat-form-field appearance="outline">
            <mat-select
              hideSingleSelectionIndicator="true"
              formControlName="marketFC"
              id="marketSelect"
              name="marketSelect"
              disableOptionCentering
            >
              <mat-option *ngFor="let market of marketList" [value]="market">
                {{ market.value }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </th>
        <th scope="col">
          <mat-form-field appearance="outline">
            <mat-select
              hideSingleSelectionIndicator="true"
              formControlName="submarketFC"
              id="submarketSelect"
              disableOptionCentering
            >
              <mat-option *ngFor="let submarket of subMarketList" [value]="submarket">
                {{ submarket.value }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </th>
        <th scope="col">
          <mat-form-field appearance="outline">
            <mat-select
              hideSingleSelectionIndicator="true"
              formControlName="productTypeFC"
              id="productSelect"
              name="productSelect"
              disableOptionCentering
            >
              <mat-option *ngFor="let product of productTypeList" [value]="product">
                {{ product.value }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </th>
      </tr>
    </tbody>
  </table>
</div>

<div class="advance-search">
  <button
    class="search-text txt-button"
    (click)="advancedSearch()"
    [disabled]="selectedSubMarket.key === 0"
    l10nTranslate
  >
    shared.advancedSearch
  </button>
</div>
